module.exports = __webpack_public_path__ + "static/media/roles-placeholder.bc4afa94.svg";